import { render, staticRenderFns } from "./RelatedPost.vue?vue&type=template&id=027c4f4a&"
import script from "./RelatedPost.vue?vue&type=script&lang=js&"
export * from "./RelatedPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports